import AppovalPageTemplatesPage from "./AppovalPageTemplatesPage"

export default AppovalPageTemplatesPage
